import { useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import toast from 'react-hot-toast';
import { db } from '../services/firebase.js';
import { saveDocument } from '../services/firestoreService.js';
import { sendAdminEmail } from '../services/emailService.js';

export const useNewsletter = () => { // Newsletter hook for PROTEGE QV ASSOCIATION
  const [loading, setLoading] = useState(false);

  /**
   * Subscribe an email address to the newsletter.
   * Deduplicates by email before saving.
   * @param {string} email
   * @param {string} [nomComplet]
   */
  const subscribe = async (email, nomComplet = '') => {
    setLoading(true);
    try {
      // Check for existing subscription
      const q = query(
        collection(db, 'newsletter_subscriptions'),
        where('email', '==', email.toLowerCase().trim())
      );
      const existing = await getDocs(q);
      if (!existing.empty) {
        toast('Vous êtes déjà inscrit(e) à notre newsletter.', { icon: 'ℹ️' });
        return true;
      }

      await saveDocument('newsletter_subscriptions', {
        email: email.toLowerCase().trim(),
        nom_complet: nomComplet || null,
        statut: 'actif',
      });

      await sendAdminEmail(
        '[PROTEGE QV] Nouvelle inscription newsletter',
        `
          <h2>Nouvelle inscription newsletter</h2>
          <p><strong>Email :</strong> ${email}</p>
          ${nomComplet ? `<p><strong>Nom :</strong> ${nomComplet}</p>` : ''}
        `
      );

      toast.success('Inscription confirmée ! Bienvenue dans la communauté PROTEGE QV.');
      return true;
    } catch (error) {
      console.error('Newsletter error:', error);
      toast.error('Erreur lors de l\'inscription. Veuillez réessayer.');
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { loading, subscribe };
};
